import { Trans, useTranslation } from 'react-i18next';
import { MARKET } from '@/common/constants/markets';
import { FormattedMoney } from '@/web/components/FormattedMoney/FormattedMoney';
import { useMarket } from '@/web/hooks/useMarket';
import {
  IconCircleExclamationRegular,
  LabeledValue,
  Text,
  Tooltip,
} from '@coverflex-tech/hypernova';
import { TMoney } from '@coverflex-tech/hypernova-utils';
import css from './InsurancePaidByEmployeeRow.module.css';

export const InsurancePaidByEmployeeRow = ({
  cost,
}: TInsurancePaidByEmployeeRowProps) => {
  const { t } = useTranslation();
  const { slug } = useMarket();

  return (
    <LabeledValue
      orientation="horizontal"
      label={
        <div className={css.startWrapper}>
          <Text bold>
            {t('dashboard.insurance.upgrade_plan.card.employee_total_label')}
          </Text>
          {slug === MARKET.PT && (
            <Tooltip
              content={<Trans i18nKey={'dashboard.insurance.price_info'} />}
              position="top"
            >
              <IconCircleExclamationRegular className={css.tooltipIcon} />
            </Tooltip>
          )}
        </div>
      }
      value={<FormattedMoney amount={cost} />}
    />
  );
};

export type TInsurancePaidByEmployeeRowProps = {
  cost?: TMoney;
};
